import { getStorage, ref, getMetadata } from "firebase/storage";

interface FileDetails {
  size: string;
  name: string;
}

export async function getFileDetails(
  storagePath: string
): Promise<FileDetails> {
  const storage = getStorage();
  const fileRef = ref(storage, storagePath);

  try {
    const metadata = await getMetadata(fileRef);
    const contentLength = metadata.size;
    const fileName = metadata.name;

    const fileSize =
      contentLength < 1024 * 1024
        ? `${(contentLength / 1024).toFixed(2)} KB`
        : `${(contentLength / (1024 * 1024)).toFixed(2)} MB`;

    return {
      size: fileSize,
      name: fileName,
    };
  } catch (error) {
    throw new Error(`Failed to get file details: ${error}`);
  }
}
